import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';

const BottomBar = ({ onRegisterClick }) => {
  const waUrl = `https://api.whatsapp.com/send?phone=${process.env.REACT_APP_WHATSAPP_PHONE}&text=I%27m%20interested%20UniFi%20Service`;
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-[#FF6600] text-white py-4 px-4 shadow-lg z-50">
      <div className="container mx-auto flex justify-center items-center gap-12">
        {/* Sales Assistant */}
        <a 
          href={waUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 transition-opacity hover:opacity-80"
        >
          <div className="bg-white text-[#FF6600] p-2 rounded-full">
            <MessageCircle size={24} />
          </div>
          <div>
            <p className="text-sm font-semibold">Sales Assistant</p>
            <p className="text-lg font-bold">{process.env.REACT_APP_WHATSAPP_DISPLAY}</p>
          </div>
        </a>

        {/* Divider */}
        <div className="w-px h-12 bg-white opacity-30"></div>

        {/* Bill or Technical Issue */}
        <a 
          href="tel:100"
          className="flex items-center gap-3 transition-opacity hover:opacity-80"
        >
          <div className="bg-white text-[#FF6600] p-2 rounded-full">
            <Phone size={24} />
          </div>
          <div>
            <p className="text-sm font-semibold">Bill or Technical Issue</p>
            <p className="text-lg font-bold">100 / 03-22411290</p>
          </div>
        </a>

        {/* Sign Up Button */}
        <button
          onClick={onRegisterClick}
          data-testid="bottombar-signup-btn"
          className="bg-white text-[#FF6600] px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition-all transform hover:scale-105"
        >
          SIGN UP NOW!
        </button>
      </div>
    </div>
  );
};

export default BottomBar;
